<script>
	export default {
		name: 'BaseFilterMixin',
		props: {
			filter: {
				required: true,
				type: Object
			}
		},
		methods: {
			updateFilter(values) {
				if (!Array.isArray(values)) values = [values]

				this.$set(this.filter, 'selectedValues', values)

				this.$emit('update:filter', this.filter)
			}
		}
	}
</script>